@if (!isSelfAuthoring()) {
<details-section [title]="'simulationBuilder.PERSONA_INFORMATION_TITLE' | transloco" [showDetails]="false">
  <div *ngIf="form" class="details-layout" [formGroup]="form">
    <div class="form-content">
      <div class="top-row">
        <qai-field [label]="'simulationBuilder.PERSONA_AVATAR_LABEL' | transloco">
          <qai-floating-select
            *ngIf="isReady"
            [options]="
              avatarReplicasSelectOptions ? avatarReplicasSelectOptions : []
            "
            [placeholder]="'simulationBuilder.AVATAR_SELECT_PLACEHOLDER' | transloco"
            [placement]="'below-start'"
            [offset]="4"
            [shape]="'rectangle'"
            [startIcon]="'search'"
            [value]="selectedAvatar"
            (selectionChange)="avatarReplicaSelectionChange($event)"
            [disabled]="readOnly || isUploadingBackground || isDeletingBackground"
          ></qai-floating-select>

          <qai-floating-select
            *ngIf="!isReady"
            [options]="
              avatarReplicasSelectOptions ? avatarReplicasSelectOptions : []
            "
            [placeholder]="'simulationBuilder.AVATAR_SELECT_PLACEHOLDER' | transloco"
            [placement]="'below-start'"
            [offset]="4"
            [shape]="'rectangle'"
            [startIcon]="'search'"
            [disabled]="readOnly || isUploadingBackground || isDeletingBackground"
            (selectionChange)="avatarReplicaSelectionChange($event)"
          ></qai-floating-select>
        </qai-field>

        <qai-field [label]="'simulationBuilder.PERSONA_NAME_LABEL' | transloco"
          ><input qai-input type="text" formControlName="personaName"
        /></qai-field>
      </div>
      <div class="section-wrapper">
        <qai-field
          [label]="'simulationBuilder.PERSONA_INITIAL_GREETINGS_LABEL' | transloco"
          [description]="'simulationBuilder.PERSONA_INITIAL_GREETINGS_DESCRIPTION' | transloco"
        >
          <div class="message-wrapper" formArrayName="welcomeMessage">
            <div
              class="message-controls"
              *ngFor="let ctrl of welcomeMessageControls; let i = index"
            >
              <input qai-input qaiTrimLeading type="text" [formControlName]="i" />
              <button *ngIf="i > 0" (click)="removeGreetingOption(i)" [disabled]="readOnly" class="icon-button">
                <qai-icon kind="trash" positionStart></qai-icon>
              </button>
            </div>
          </div>
        </qai-field>
        <button
          *ngIf="welcomeMessageArray.length < 5"
          qai-button
          [shape]="'normal'"
          [kind]="'tertiary'"
          [size]="'medium'"
          (click)="addGreetingOption()"
          [disabled]="isAddGreetingDisabled || readOnly"
          class="message-button"
        >
          {{ 'simulationBuilder.PERSONA_ADD_GREETING_OPTION' | transloco }}
        </button>
      </div>

      <div class="section-wrapper">
        <qai-field
          [label]="'simulationBuilder.PERSONA_RESUME_MESSAGE_LABEL' | transloco"
          [description]="'simulationBuilder.PERSONA_RESUME_MESSAGE_DESCRIPTION' | transloco"
        >
          <div class="message-wrapper" formArrayName="resumeMessage">
            <div
              class="message-controls"
              *ngFor="let ctrl of resumeMessageControls; let i = index"
            >
              <input qai-input qaiTrimLeading type="text" [formControlName]="i" />
          
              <button
                *ngIf="i > 0"
                (click)="removeResumeMessage(i)"
                [disabled]="readOnly"
                class="icon-button"
              >
                <qai-icon kind="trash" positionStart></qai-icon>
              </button>
            </div>
          </div>
        </qai-field>
        <button
          *ngIf="resumeMessageArray.length < 5"
          qai-button
          [shape]="'normal'"
          [kind]="'tertiary'"
          [size]="'medium'"
          (click)="addResumeMessage()"
          [disabled]="isAddResumeMessageDisabled || readOnly"
          class="message-button"
        >
          {{ 'simulationBuilder.PERSONA_ADD_MESSAGE_OPTION' | transloco }}
        </button>
      </div>
    </div>

    <div class="avatar-image">
      <div
        *ngIf="isUploadingBackground || isDeletingBackground"
        class="processing-placeholder"
      >
        <qai-loading [size]="'medium'"></qai-loading>
        <p class="loading-text">{{ isUploadingBackground ? ('simulationBuilder.PERSONA_UPLOADING' | transloco) : ('simulationBuilder.PERSONA_DELETING' | transloco) }}</p>
      </div>
      <img
        *ngIf="!selectedAvatarThumbnail && !avatarReplicaSelected && !uploadedBackgroundImage && !isUploadingBackground && !isDeletingBackground"
        src="/assets/img/simulation-images/simulation-avatar.svg"
        [alt]="'simulationBuilder.AVATAR_ALT' | transloco"
        class="placeholder-image"
      />

      <img
        *ngIf="!avatarReplicaSelected && uploadedBackgroundImage && !isUploadingBackground && !isDeletingBackground"
        [noCacheSrc]="uploadedBackgroundImage"
        [alt]="'simulationBuilder.PERSONA_CUSTOM_BG_PREVIEW_ALT' | transloco"
        class="preview-image"
      />

      <img
        *ngIf="selectedAvatarThumbnail && !uploadedBackgroundImage && !isUploadingBackground && !isDeletingBackground"
        [noCacheSrc]="selectedAvatarThumbnail"
        [alt]="'simulationBuilder.PERSONA_AVATAR_THUMBNAIL_ALT' | transloco"
        class="avatar-thumbnail"
      />

      <img
        *ngIf="avatarReplicaSelected && uploadedBackgroundImage && processedImageDataUrl && !isUploadingBackground && !isDeletingBackground"
        [noCacheSrc]="processedImageDataUrl"
        [alt]="'simulationBuilder.PERSONA_AVATAR_WITH_BG_ALT' | transloco"
        class="processed-avatar-image"
      />

      <div
        *ngIf="avatarReplicaSelected && uploadedBackgroundImage && !processedImageDataUrl && !isUploadingBackground && !isDeletingBackground"
        class="processing-placeholder"
      >
        <qai-loading [size]="'medium'"></qai-loading>
        <p class="loading-text">{{ 'simulationBuilder.PERSONA_PROCESSING_IMAGE' | transloco }}</p>
      </div>
      <div class="custom-background-header">
        <span class="custom-background-label">{{ 'simulationBuilder.PERSONA_CUSTOM_BACKGROUND_LABEL' | transloco }}</span>

        <qai-label
          *ngIf="uploadedBackgroundImage && !isDeletingBackground && !isUploadingBackground"
          kind="secondary"
          [size]="'medium'"
          [weight]="'regular'"
          class="remove-background-label"
          (click)="removeCustomBackground()"
        >
          <qai-icon kind="trash" positionStart />
          {{ 'simulationBuilder.PERSONA_REMOVE_BACKGROUND' | transloco }}
        </qai-label>
      </div>

      <qai-file-upload
        *ngIf="showFileUpload"
        [acceptedFileTypes]="'image/png, image/jpeg'"
        [maxSizeInMB]="2"
        [disabled]="isUploadingBackground || isDeletingBackground || readOnly"
        (fileSelected)="onFileSelected($event)"
        (fileDropped)="onFileDropped($event)"
        [acceptedAspectRatio]="'16:9'"
        [aspectRatioTolerance]="0.01"
      >
        <div class="upload-content">
          <p class="upload-title">
            <span class="upload-link" [class.disabled]="isUploadingBackground || isDeletingBackground || readOnly">{{ uploadedBackgroundImage ? ('simulationBuilder.PERSONA_CLICK_TO_REPLACE' | transloco) : ('simulationBuilder.CLICK_TO_UPLOAD' | transloco) }}</span>
            <span class="upload-text"> {{ 'simulationBuilder.OR_DRAG_AND_DROP' | transloco }}</span>
          </p>
          <p class="upload-description">
            {{ 'simulationBuilder.PERSONA_UPLOAD_DESCRIPTION' | transloco }}
          </p>
        </div>
      </qai-file-upload>

      <div *ngIf="uploadError" class="error-message upload-error">
        <qai-icon kind="alert-circle" />
        <span>{{ uploadError }}</span>
      </div>

      <div *ngIf="deleteError" class="error-message delete-error">
        <qai-icon kind="alert-circle" />
        <span>{{ deleteError }}</span>
      </div>
    </div>
  </div>
</details-section>
} @else {
<details-section [title]="'simulationBuilder.SIM_INFORMATION_TITLE' | transloco" [showDetails]="false">
  <avatar-look-voice-selector
    [form]="selfAuthoringPersonaForm"
    [appearanceLabel]="'simulationBuilder.AVATAR_APPEARANCE_LABEL'"
    [isSelfAuthoring]="isSelfAuthoring()"
    [conversePromptManualOverride]="conversePromptManualOverride()"
    (avatarChange)="onAvatarSelected($event)"
  >
    <qai-field
      fieldsBefore
      [label]="'simulationBuilder.NAME_LABEL' | transloco"
      [error]="simulationNameErrorKey ? (simulationNameErrorKey | transloco) : ''"
    >
      @if (simulationNameControl) {
        <input qai-input type="text" [formControl]="simulationNameControl" [readonly]="isSimulationNameReadOnly" />
      }
    </qai-field>
  </avatar-look-voice-selector>
</details-section>
}
